import { Button, Container, Group, Text, Title } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { ErrorComponentProps, Link } from '@tanstack/react-router';
import { isAxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import { PageError } from '@/core/components/PageError/PageError';
import classes from '@/core/components/PageError/PageError.module.css';

export function TravelRequestNoAccess() {
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <Container>
        <div className={classes.label}>
          <IconLock size={60} />
        </div>
        <Title className={classes.title}>{t('travel.requests.forbidden.title')}</Title>
        <Text
          c="dimmed"
          ta="center"
          mb="md"
        >
          {t('travel.requests.forbidden.description')}
        </Text>
        <Group justify="center">
          <Button
            variant="outline"
            size="md"
            component={Link}
            to="/travel"
          >
            {t('travel.requests.forbidden.back')}
          </Button>
        </Group>
      </Container>
    </div>
  );
}

export function TravelRequestLoadError({ error }: Pick<ErrorComponentProps, 'error'>) {
  if (isAxiosError(error) && error.response?.status === 403) {
    return <TravelRequestNoAccess />;
  }

  return <PageError />;
}
